import { FC } from 'react'

import { SequenceMenu, SetIsOpen } from '@sequencehq/core-components'
import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

import { UnpublishWorkflowMenuItem } from './UnpublishWorkflow.menuItem'
import { PublishWorkflowMenuItem } from './PublishWorkflow.menuItem'
import { ArchiveWorkflowMenuItem } from './ArchiveWorkflow.menuItem'
import { usePermissions } from 'lib/rbac'

type Props = {
  automationId: string
  onOpenChange?: (isOpen: boolean) => void
}

export const WorkflowCardMenu: FC<Props> = ({ automationId, onOpenChange }) => {
  const versionQuery = useQuery(
    dashboardv99990101Client.getAutomationVersions,
    { automationId }
  )

  const permissions = usePermissions()
  const version = versionQuery.data?.items.at(0)

  if (!permissions.can('org.watchtower:update')) {
    return null
  }

  return (
    <SequenceMenu
      data-testid={`automations.workflowCard.${automationId}.menu`}
      variant="ghost"
      alignment="bottom-right"
      onOpenChange={onOpenChange}
      disabled={versionQuery.isLoading}
      items={
        version
          ? [
              ...(version.active
                ? [
                    ({ setIsOpen }: { setIsOpen?: SetIsOpen }) => (
                      <UnpublishWorkflowMenuItem
                        key="unpublish-workflow"
                        automationId={automationId}
                        versionId={version.id}
                        onSuccess={() => {
                          setIsOpen?.(false)
                        }}
                      />
                    )
                  ]
                : [
                    ({ setIsOpen }: { setIsOpen?: SetIsOpen }) => (
                      <PublishWorkflowMenuItem
                        key="publish-workflow"
                        automationId={automationId}
                        versionId={version.id}
                        triggerType={version.triggerType}
                        onSuccess={() => {
                          setIsOpen?.(false)
                        }}
                      />
                    )
                  ]),
              ...(permissions.can('org.watchtower:archive')
                ? [
                    ({ setIsOpen }: { setIsOpen?: SetIsOpen }) => (
                      <ArchiveWorkflowMenuItem
                        key="archive-workflow"
                        automationId={automationId}
                        versionId={version.id}
                        onSuccess={() => {
                          setIsOpen?.(false)
                        }}
                      />
                    )
                  ]
                : [])
            ]
          : []
      }
    />
  )
}
